module.exports = __webpack_public_path__ + "img/icon.3eff35b5.svg";